import { useEffect, useState } from "react";
import type { ComponentType } from "react";

type PlayerProps = Record<string, unknown>;
type PlayerComponent = ComponentType<PlayerProps>;

export function ClientPlyr(props: PlayerProps) {
  const [Plyr, setPlyr] = useState<PlayerComponent | null>(null);

  useEffect(() => {
    let mounted = true;

    Promise.all([
      import("plyr-react"),
      // Load plyr css on demand only when player mounts
      import("plyr-react/plyr.css"),
    ]).then(([module]) => {
      if (mounted) {
        setPlyr(() => module.Plyr as unknown as PlayerComponent);
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  if (!Plyr) {
    return <div aria-busy="true" className="w-full h-full bg-black/60" />;
  }

  return <Plyr {...props} />;
}
